import type { ModuleManifest } from '@titan/shared';

/**
 * Ticketing Platform (Titan Tickets). Spec 03. Flip `shipped` when the module is ready
 * for clients; until then only DinoCloud staff see its screens.
 */
export const manifest: ModuleManifest = {
  key: 'tick',
  label: 'Ticketing Platform',
  description: 'Queue, ticket detail, automation rules',
  eyebrow: 'ticketing platform',
  basePath: '/tickets',
  navGroup: { key: 'tick', label: 'Ticketing Platform', order: 50 },
  navItems: [
    { key: 'queue', label: 'Tickets', path: '/tickets' },
    { key: 'service', label: 'Service level', path: '/tickets/service' },
    { key: 'rules', label: 'Automation rules', path: '/tickets/rules' },
    { key: 'analytics', label: 'Analytics', path: '/tickets/analytics' },
    { key: 'rex', label: 'Rex preferences', path: '/tickets/rex' },
  ],
  localPort: 4010,
  shipped: true,
  version: '0.1.0',
};
